import { Box, Card, Grid, Typography } from '@mui/material'
import { useUser } from '../../../hooks/useUser'
import { UserRole } from '../../../types/user'

export interface SalesData {
  today: string
  title: string
  persent: string
  icon: JSX.Element
  bnb: string
  isShow?: boolean
}
interface IProps {
  data: SalesData[]
}

const SummaryCard = ({ data }: IProps) => {
  const { user } = useUser()
  return (
    <Grid container spacing={2}>
      {user.roles?.includes(UserRole.USER) ? (
        <>
          {data.map(
            (item, index) =>
              item.bnb === 'commission' &&
              item.isShow && (
                <Grid item xs={12} md={12} lg={12} key={index}>
                  <Card
                    sx={{
                      borderRadius: '10px',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                      display: 'flex',
                      height: '100px',
                      alignItems: 'center',
                      justifyContent: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    <Box>{item.icon}</Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        width: '100%',
                        padding: '10px',
                      }}
                    >
                      <Typography
                        variant="h6"
                        color={'text.secondary'}
                        minWidth={200}
                      >
                        {item.today}
                      </Typography>
                      <Typography variant="h6" minWidth={200}>
                        {item.title}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ),
          )}
        </>
      ) : (
        <>
          {data.map(
            (item, index) =>
              item.isShow && (
                <Grid item xs={12} md={4} lg={3} key={index}>
                  <Card
                    sx={{
                      borderRadius: '10px',
                      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                      display: 'flex',
                      height: '100px',
                      alignItems: 'center',
                      justifyContent: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    <Box>{item.icon}</Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        padding: '10px',
                      }}
                    >
                      <Typography
                        variant="h6"
                        color={'text.secondary'}
                        minWidth={200}
                      >
                        {item.today}
                      </Typography>
                      <Typography variant="h6" minWidth={200}>
                        {item.title}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ),
          )}
        </>
      )}
    </Grid>
  )
}

export default SummaryCard
